import { Box, Grid, GridItem, Heading, VStack } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { CreditAgreement, Util } from '@finley-technologies/finley-types';

import { colors } from '~/packages/common-frontend/colors';

type FacilitySummaryRowProps = {
  label: string;
  value: Util.Primitive;
};
const FacilitySummaryRow = ({ label, value }: FacilitySummaryRowProps) => {
  return (
    <Grid
      templateColumns="repeat(3, 1fr)"
      backgroundColor={colors.gray[20]}
      fontWeight={600}
      width="100%"
    >
      <GridItem colSpan={2} mr="16px" p="16px">
        {label}
      </GridItem>
      <GridItem colSpan={1} p="16px">
        {value}
      </GridItem>
    </Grid>
  );
};

type DigitalMonthlyReportFacilitySummaryProps = {
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
};
export const DigitalMonthlyReportFacilitySummary = ({
  creditAgreement,
}: DigitalMonthlyReportFacilitySummaryProps) => {
  const {
    facilityMechanics: {
      parties: { capitalProviders },
      closingDate,
    },
  } = creditAgreement;

  const commitmentAmount = _.sumBy(
    capitalProviders,
    (capitalProvider) => capitalProvider.commitmentAmount.value,
  );

  return (
    <Box
      backgroundColor="white"
      borderRadius="8px"
      borderWidth="1px"
      borderColor={colors.gray[200]}
      padding="40px"
    >
      <Heading as="h2" fontSize="24px" mb="24px">
        Facility Summary
      </Heading>
      <VStack spacing="8px" width="100%">
        <FacilitySummaryRow
          label="Commitment Amount"
          value={commonUtils.numberToCurrencyWithSymbol({
            number: commitmentAmount,
          })}
        />
        <FacilitySummaryRow label="Closing Date" value={closingDate.value} />
      </VStack>
    </Box>
  );
};
